import React from "react";
import "./style.scss";

function Header() {
  return (
    <div className="header">
      <div className="header-content">
        <div className="header-title">
          <h1>Countries</h1>
        </div>
      </div>
    </div>
  );
}

export default Header;
